import { UpdateRoomRosterEventAdapter } from '~analytics/adapters/UpdateRoomRosterEventAdapter';
import { translate } from '~l10n/client';

let Backbone = require('backbone');
let _ = require('underscore');
let roomModel = require('room');
let user = require('user');
let Constants = require('Constants');
let platform = require('Platform');
let Validations = require('Validations');
let popup = require('../../../../shared/components/popup/PopupController');
let request = require('../../../../../shared/Request');

let RoomsModel = Backbone.Model.extend({
  defaults: function () {
    return {
      /**
       * the number of seconds that we display the green notifier when some is saved
       * also used by the error notifier on the add students popup
       * @type {Number}
       */
      notify_timer: 2000,
      /**
       * The keys of this object are the IDs of rooms that were not the "current room" when their roster was viewed.
       * We track these so we can unsubscribe from their pubnub channels when presence is no longer needed.
       */
      listeners: {},
    };
  },

  initialize: function () {
    this.filtersApplied = false; // Whether the teacher has applied a room filter. When this is false, the default room is at the top.
    this.maxStudents = Constants.MAX_FREE_ROSTERED_STUDENTS; // Maximum number of students that can be added to a roster. Computed anew for rosters that already have students.
    this.newStudents = []; // The list of new students to be added to a roster.
    this.roomFilter = 'roomNameASC'; // The filter applied to the rooms view.
    this.roomsList = []; // The list of room objects.
    this.studentFilter = 'nameASC'; // The filter applied to the current student roster.
  },

  // ====================================================
  // =================== manage rooms ===================
  // ====================================================

  /**
   * method used to update the the list of rooms on the page
   * this happens when filtering or when adding/deleting rooms
   * it will filter the list and then trigger a render
   *
   * @param  {Array} list     the list of rooms (optional)
   */
  updateRoomsList: function (list) {
    let roomsList = list || this.roomsList;

    switch (this.roomFilter) {
      case 'roomNameASC':
        roomsList = _.sortBy(roomsList, 'name');
        break;
      case 'roomNameDSC':
        roomsList = _.sortBy(roomsList, 'name').reverse();
        break;
      case 'inMenuASC':
        roomsList = _.sortBy(_.sortBy(roomsList, 'name'), 'in_menu').reverse();
        break;
      case 'inMenuDSC':
        roomsList = _.sortBy(_.sortBy(roomsList, 'name'), 'in_menu');
        break;
      case 'statusASC':
        roomsList = _.sortBy(_.sortBy(roomsList, 'name'), 'active').reverse();
        break;
      case 'statusDSC':
        roomsList = _.sortBy(_.sortBy(roomsList, 'name'), 'active');
        break;
    }

    this.roomsList = roomsList;

    this.trigger('roomsList:updated');
  },

  getRoomsList: function (callback) {
    let route = Backbone.history.fragment;

    this.filtersApplied = false;
    this.roomFilter = 'roomNameASC';

    request.get({
      url: `${window.APP_CONFIG.BACKEND_HOST}/rooms/api/list/`,
      success: (data) => {
        if (Backbone.history.fragment !== route) {
          return;
        }

        if ('rooms' in data) {
          _.each(data.rooms, function (room) {
            room.name = room.name.toLowerCase();
          });

          // If a callback is passed, it will handle the result explicitly. One case for this is
          // updating the header rooms menu, when adding/deleting a room causes the user to have
          // more than one room or only one room.
          if (callback) {
            callback(true);
          } else {
            this.updateRoomsList(data.rooms);
          }
        } else {
          if (_.isFunction(options.error)) {
            options.error(data);
          }
        }
      },
      error: () => {
        if (callback) {
          callback(false);
        }
      },
    });
  },

  shareRoom: function (roomName, generateCode) {
    let sharedRoom = _.findWhere(this.roomsList, { name: roomName });
    // if the room was't shared before and it doesn't have a share code, send request to api

    if (
      _.isNull(sharedRoom.share_url) ||
      _.isUndefined(sharedRoom.share_url) ||
      generateCode
    ) {
      request.post({
        url: `${window.APP_CONFIG.BACKEND_HOST}/rooms/api/share/`,
        data: {
          room_name: roomName,
        },
        success: (data) => {
          sharedRoom.share_url = data.url;
          let obj = {};
          obj.roomName = roomName;
          obj.url = data.url;
          obj.showInfo = generateCode;
          this.trigger('share_room:success', obj);
        },
        error: (response) => {
          console.error(response);
        },
      });
    } else {
      let obj = {};
      obj.roomName = roomName;
      obj.url = sharedRoom.share_url;
      obj.showInfo = generateCode;
      this.trigger('share_room:success', obj);
    }
  },

  deleteRoom: function (room_name, callback) {
    request.del({
      url: `${window.APP_CONFIG.BACKEND_HOST}/rooms/api/room/${room_name}/`,
      success: () => {
        let deletedRoom = _.findWhere(this.roomsList, { name: room_name });
        deletedRoom.notify = {
          status: true,
          message: translate('Room deleted!'),
        };

        this.updateRoomsList();

        setTimeout(() => {
          let newRoomsList = _.without(
            this.roomsList,
            _.findWhere(this.roomsList, { name: room_name })
          );
          this.updateRoomsList(newRoomsList);

          // If the user deleted the current room, change to the default room, which is now the current room.
          if (
            roomModel.getRoomName().toLowerCase() === room_name.toLowerCase()
          ) {
            this.changeCurrentRoom(roomModel.get('name'));
          }
        }, this.get('notify_timer'));

        if (callback) {
          callback(true);
        }
      },
      error: (response) => {
        console.error(response);
        if (callback) {
          callback(false);
        }
      },
    });
  },

  changeCurrentRoom: function () {
    this.trigger('current_room:changed');
  },

  changeRoomStatus: function (room_id, status, callback) {
    request.post({
      url: `${window.APP_CONFIG.BACKEND_HOST}/rooms/api/status/`,
      data: {
        statuses: [
          {
            room_id: room_id,
            in_menu: status,
          },
        ],
      },
      success: () => {
        let changedRoom = _.findWhere(this.roomsList, { id: room_id });
        changedRoom.in_menu = status;

        if (roomModel.getRooms()) {
          changedRoom = _.findWhere(roomModel.getRooms(), { id: room_id });

          if (changedRoom) {
            changedRoom.in_menu = status;
          }
        }

        callback(true);
      },
      error: (response) => {
        console.error(response);
        callback();
      },
    });
  },

  // check if values of list parameter are different
  allValuesSame: function (list) {
    for (let i = 1; i < list.length; i++) {
      if (list[i] !== list[0]) return false;
    }

    return true;
  },

  // check if all rooms are in menu or not
  checkListOfRooms: function (type) {
    let model = this;

    let list = [];

    if (type === 'in-menu') {
      _.each(model.roomsList, function (room) {
        list.push(room.in_menu);
      });
    } else if (type === 'status') {
      _.each(model.roomsList, function (room) {
        list.push(room.active);
      });
    } else {
      _.each(model.roomsList, function (room) {
        list.push(room.students_logged_in);
      });
    }

    return this.allValuesSame(list);
  },

  filterRooms: function (type) {
    if (!this.checkListOfRooms(type) || type === 'room-name') {
      if (type === 'room-name') {
        this.roomFilter =
          this.roomFilter === 'roomNameASC' ? 'roomNameDSC' : 'roomNameASC';
      } else if (type === 'in-menu') {
        this.roomFilter =
          this.roomFilter === 'inMenuASC' ? 'inMenuDSC' : 'inMenuASC';
      } else if (type === 'status') {
        this.roomFilter =
          this.roomFilter === 'statusASC' ? 'statusDSC' : 'statusASC';
      }

      this.filtersApplied = true;
      this.updateRoomsList();
    }
  },

  manageRoster: function (room_name) {
    let activeRoster = _.findWhere(this.roomsList, { name: room_name });
    this.set('roster_in_edit', activeRoster);

    if (!activeRoster.rosterInEdit) {
      for (let item of this.roomsList) {
        item.rosterInEdit = false;
      }
      activeRoster.rosterInEdit = true;
    } else {
      activeRoster.rosterInEdit = false;
    }
    this.updateRoomsList();
  },

  /**
   * Called after the teacher imports a roster using excel or csv.
   * @param  {String} roomName the name of the room
   * @param  {Array} students  the list of students
   */
  rosterImported: function (roomName, students) {
    let activeRoom = _.findWhere(this.roomsList, { name: roomName });
    activeRoom.rostered = true;
    activeRoom.rosterInEdit = true;
    activeRoom.roster = students;
    activeRoom.student_count = students.length;
    activeRoom.notify = {
      status: true,
      message: translate('{0} students imported!').format(students.length),
    };

    if (activeRoom.name === roomModel.getRoomName()) {
      roomModel.set('rostered', true);
      roomModel.set('students', students);
    }

    this.studentFilter = 'nameDSC';
    this.filterStudents('name');
    this.set('roster_in_edit', activeRoom);
    this.updateRoomsList();
    setTimeout(() => {
      activeRoom.notify = '';
      this.updateRoomsList();
    }, Constants.BANNER_TIMEOUT);
  },

  deleteRoster: function () {
    let deletedRoster = this.get('roster_in_edit');

    request.del({
      url: `${window.APP_CONFIG.BACKEND_HOST}/rooms/api/${deletedRoster.name}/roster/`,
      success: () => {
        deletedRoster.roster = [];
        deletedRoster.student_count = 0;
        deletedRoster.rostered = false;
        deletedRoster.rosterInEdit = false;
        deletedRoster.notify = {
          status: true,
          message: translate('Roster deleted!'),
        };

        this.updateRoomsList(this.roomsList);

        if (deletedRoster.name === roomModel.getRoomName()) {
          roomModel.set('rostered', false);
          roomModel.set('students', []);
          Backbone.history.navigate('rooms', { trigger: true });
        }

        setTimeout(() => {
          deletedRoster.notify = '';
          this.updateRoomsList();
        }, this.get('notify_timer'));

        this.updateRoomsList(this.roomsList);
      },
      error: (response) => {
        console.log('Error deleting roster:', response);
      },
    });
  },

  // ====================================================
  // =================== manage students ================
  // ====================================================
  filterFunction: function (type) {
    let rosterInEdit = this.get('roster_in_edit');
    let numbers = [];
    let strings = [];
    _.each(rosterInEdit.roster, function (student) {
      if (_.isNaN(Number(student.student_id))) {
        strings.push(student);
      } else {
        numbers.push(student);
      }
    });

    numbers = _.sortBy(numbers, function (number) {
      return Number(number.student_id);
    });
    strings = _.sortBy(strings, function (string) {
      return string.student_id;
    });

    if (type === 'DSC') {
      numbers = numbers.reverse();
      strings = strings.reverse();
    }

    return numbers.concat(strings);
  },

  // check if all rooms are in menu or not
  checkListOfstudentsInRoom: function () {
    let model = this;

    let rosterInEdit = model.get('roster_in_edit');
    let list = [];
    _.each(rosterInEdit.roster, function (student) {
      list.push(student.logged_in);
    });

    return this.allValuesSame(list);
  },

  filterStudents: function (type) {
    let rosterInEdit = this.get('roster_in_edit');

    if (type === 'name') {
      this.studentFilter =
        this.studentFilter === 'nameASC' ? 'nameDSC' : 'nameASC';
    } else if (type === 'student_id') {
      this.studentFilter =
        this.studentFilter === 'student_idASC'
          ? 'student_idDSC'
          : 'student_idASC';
    } else if (type === 'email') {
      this.studentFilter =
        this.studentFilter === 'emailASC' ? 'emailDSC' : 'emailASC';
    } else if (type === 'presence') {
      // do the sort by presence only if the values are different
      if (this.checkListOfstudentsInRoom()) {
        return;
      } else {
        this.studentFilter =
          this.studentFilter === 'presenceASC' ? 'presenceDSC' : 'presenceASC';
      }
    }

    switch (this.studentFilter) {
      case 'nameASC':
        rosterInEdit.roster = _.sortBy(rosterInEdit.roster, function (num) {
          return num.last_name.toLowerCase();
        });
        break;
      case 'nameDSC':
        let newList = _.sortBy(rosterInEdit.roster, function (num) {
          return num.last_name.toLowerCase();
        });
        rosterInEdit.roster = newList.reverse();
        break;
      case 'presenceASC':
        rosterInEdit.roster = _.sortBy(
          _.sortBy(rosterInEdit.roster, 'last_name'),
          'logged_in'
        ).reverse();
        break;
      case 'presenceDSC':
        rosterInEdit.roster = _.sortBy(
          _.sortBy(rosterInEdit.roster, 'last_name'),
          'logged_in'
        );
        break;
      case 'student_idASC':
        rosterInEdit.roster = this.filterFunction('ASC');
        break;
      case 'student_idDSC':
        rosterInEdit.roster = this.filterFunction('DSC');
      case 'emailASC':
        rosterInEdit.roster = _.sortBy(rosterInEdit.roster, (item) => {
          // Sort by email, if empty sort by student id
          return item.email || item.student_id;
        });
        break;
      case 'emailDSC':
        rosterInEdit.roster = _.sortBy(rosterInEdit.roster, (item) => {
          // Sort by email, if empty sort by student id
          return item.email || item.student_id;
        });
        rosterInEdit.roster = rosterInEdit.roster.reverse();
        break;
    }

    this.updateRoomsList();
  },

  editStudentButtonClicked: function (studentID) {
    let activeRoster = this.get('roster_in_edit');
    let editedStudent = _.findWhere(activeRoster.roster, {
      student_id: studentID,
    });
    let clonedStudent = {
      first_name: editedStudent.first_name,
      last_name: editedStudent.last_name,
      student_id: editedStudent.student_id,
    };
    editedStudent.studentClone = _.clone(clonedStudent);
    editedStudent.inEdit = true;
    this.updateRoomsList();
  },

  cancelEditStudentButtonClicked: function (studentID, singular) {
    let activeRoster = this.get('roster_in_edit');
    // if new singular student
    if (singular) {
      activeRoster.new_students_list = [];
      // set the roster in edit false
      // if adding a new student on mobile to a non rostered room
      if (platform.isMobile() && !platform.isTablet && !activeRoster.rostered) {
        activeRoster.rosterInEdit = false;
      }
    } else {
      let editedStudent = _.findWhere(activeRoster.roster, { id: studentID });

      editedStudent.first_name = editedStudent.studentClone.first_name;
      editedStudent.last_name = editedStudent.studentClone.last_name;
      editedStudent.student_id = editedStudent.studentClone.student_id;

      editedStudent.inEdit = false;
      editedStudent.errors = {};
    }

    this.updateRoomsList();
  },

  isIdDuplicated: function (studentId, updateStudent) {
    let room = this.get('roster_in_edit');

    let rosterCount = _.countBy(room.roster, function (student) {
      return student.student_id === studentId;
    });

    // Remove the current ID from the checklist when editing an existing student.
    let condition = rosterCount['true'] > 0;

    if (updateStudent) {
      condition = rosterCount['true'] - 1 > 0;
    }

    if (condition) {
      return true;
    } else {
      rosterCount = _.countBy(this.newStudents, function (student) {
        return student.student_id === studentId;
      });

      return rosterCount['true'] - 1 > 0;
    }
  },

  isEmailDuplicated: function (email, updateStudent) {
    // Don't bother checking empty emails
    if (email === null || email === '') {
      return false;
    }

    let room = this.get('roster_in_edit');

    let rosterCount = _.countBy(room.roster, function (student) {
      return student.email === email;
    });

    // Remove the current email from the checklist when editing an existing student.
    let condition = rosterCount['true'] > 0;

    if (updateStudent) {
      condition = rosterCount['true'] - 1 > 0;
    }

    if (condition) {
      return true;
    } else {
      rosterCount = _.countBy(this.newStudents, function (student) {
        return student.email === email;
      });

      return rosterCount['true'] - 1 > 0;
    }
  },

  validateStudent: function (element, value, indexPos, oldStudentID) {
    let activeRoster = this.get('roster_in_edit');
    let student = {};

    if (indexPos === 'noIndex') {
      // Validating an existing student
      student = _.findWhere(activeRoster.roster, { id: oldStudentID });
    } else {
      // Validating a new student
      student = _.findWhere(this.newStudents, { indexPos: indexPos });
      student.hideTooltip = this.newStudents.length > 1;
    }

    let errors = student.errors ? student.errors : {};

    switch (element) {
      case 'first_name':
        if (!value) {
          errors.first_name = translate('Please provide a first name.');
        } else {
          errors.first_name = null;
        }
        student.errors = errors;
        student.first_name = value;
        break;
      case 'last_name':
        if (!value) {
          errors.last_name = translate('Please provide a last name.');
        } else {
          errors.last_name = null;
        }
        student.errors = errors;
        student.last_name = value;
        break;
      case 'student_id':
        if (!value) {
          errors.student_id = translate('Please provide an ID.');
        } else {
          if (this.isIdDuplicated(value)) {
            errors.student_id = translate('This ID is already in use.');
          } else {
            errors.student_id = null;
          }
        }
        student.errors = errors;
        student.student_id = value;
        break;
      case 'email':
        if (value) {
          if (this.isEmailDuplicated(value)) {
            errors.email = translate('This email is already in use.');
          } else if (!Validations.isValidEmail(value)) {
            errors.email = translate('Please enter a valid email');
          } else {
            errors.email = null;
          }
        }
        student.errors = errors;
        student.email = value;
    }

    return student;
  },

  updateStudent: function (roomId, student_id) {
    if (_.isBoolean(student_id) && student_id) {
      this.saveNewStudents(roomId, true);
    } else {
      this.updateExistingStudent(roomId, student_id);
    }
  },

  updateExistingStudent: function (roomId, student_id) {
    let errors = {};
    let activeRoster = this.get('roster_in_edit');
    let editedStudent = _.findWhere(activeRoster.roster, { id: student_id });

    // Revalidate the student.
    if (editedStudent.first_name === '') {
      errors.first_name = {
        isValid: false,
        errorMsg: translate('Please provide a first name.'),
      };
    }

    if (editedStudent.last_name === '') {
      errors.last_name = {
        isValid: false,
        errorMsg: translate('Please provide a last name.'),
      };
    }

    if (editedStudent.student_id === '') {
      errors.student_id = {
        isValid: false,
        errorMsg: translate('Please provide an ID.'),
      };
    } else {
      if (this.isIdDuplicated(editedStudent.student_id, true)) {
        errors.student_id = {
          isValid: false,
          errorMsg: translate('This ID is already in use.'),
        };
      }
    }

    if (editedStudent.email) {
      if (this.isEmailDuplicated(editedStudent.email, true)) {
        errors.email = {
          isValid: false,
          errorMsg: translate('This email is already in use.'),
        };
      }
      if (!Validations.isValidEmail(editedStudent.email)) {
        errors.email = {
          isValid: false,
          errorMsg: translate('Please enter a valid email'),
        };
      }
    }

    editedStudent.errors = errors;

    if (_.isEmpty(errors)) {
      request.put({
        url: `${window.APP_CONFIG.TEACHER_SERVICE}/rooms/${roomId}/roster/student/${editedStudent.id}`,
        data: editedStudent,
        success: () => {
          editedStudent.inEdit = false;
        },
        error: (response) => {
          console.error(response);
          popup.render({
            title: translate('Unknown Error'),
            message: translate(
              'This roster is currently unavailable. Please try again later.'
            ),
          });
        },
        complete: () => {
          this.updateRoomsList();
        },
      });
    }
  },

  deleteStudent: function (student, roomId) {
    let roomInEdit = this.get('roster_in_edit');

    request.del({
      url: `${window.APP_CONFIG.TEACHER_SERVICE}/rooms/${roomId}/roster/student/${student.id}`,
      success: () => {
        const oldStudentCount = roomInEdit.student_count ?? 0;
        const newStudentCount = oldStudentCount - 1;

        new UpdateRoomRosterEventAdapter({
          newStudentCount,
          oldStudentCount,
        }).sendAnalytics();

        roomInEdit.roster = _.without(
          roomInEdit.roster,
          _.findWhere(roomInEdit.roster, { id: student.id })
        );

        roomInEdit.notify = {
          status: true,
          message: translate('Student deleted!'),
        };

        roomInEdit.student_count--;

        if (roomInEdit.student_count === 0) {
          roomInEdit.rostered = false;
          roomInEdit.rosterInEdit = false;
        }

        // if a student was deleted from the current room
        if (roomId == roomModel.getRoomId()) {
          roomModel.set({
            students: roomInEdit.roster,
            student_count: roomInEdit.student_count,
            rostered: roomInEdit.student_count !== 0,
          });
          Backbone.history.navigate('rooms', { trigger: true });
        }

        this.updateRoomsList();

        setTimeout(() => {
          roomInEdit.notify = '';
          this.updateRoomsList();
        }, this.get('notify_timer'));
      },
      error: (response) => {
        popup.render({
          title: translate('Unknown Error'),
          message: translate(
            'This roster is currently unavailable. Please try again later.'
          ),
        });
      },
    });
  },

  /**
   * =========================
   * ADD NEW STUDENTS ACTIONS
   * =========================
   */

  /**
   * method used to show when the user chooses to manually add new students
   * get the max number of new students from the model
   * and trigger the select new students popup
   */
  addStudentsManually: function () {
    let activeRoster = this.get('roster_in_edit');

    if (activeRoster.rostered) {
      this.maxStudents =
        Constants.MAX_PRO_ROSTERED_STUDENTS - activeRoster.roster.length;
    } else {
      this.maxStudents = Constants.MAX_PRO_ROSTERED_STUDENTS;
    }

    this.trigger('select_new_students_popup:success', {
      roomName: activeRoster.name,
      roomId: activeRoster.id,
    });
  },

  addOneStudent: function (roomId) {
    this.addStudents(1, 'oneStudent', roomId);
  },

  addStudents: function (students, param, roomId) {
    let newStudents = [];

    for (let i = 1; i <= students; i++) {
      newStudents.push({
        first_name: '',
        last_name: '',
        student_id: '',
        email: null,
        inEdit: true,
        indexPos: i,
        newStudent: true,
      });
    }

    this.newStudents = newStudents;

    if (param === 'oneStudent') {
      let activeRoster = this.get('roster_in_edit');
      activeRoster.new_students_list = newStudents;

      if (platform.isMobile() && !platform.isTablet) {
        activeRoster.message = true;
      }

      this.updateRoomsList();
    } else {
      this.trigger('new_students_popup:success', roomId);
    }
  },

  addOneNewStudent: function () {
    let newStudents = this.newStudents;
    let listLength = newStudents.length;

    newStudents.push({
      first_name: '',
      last_name: '',
      student_id: '',
      email: null,
      inEdit: true,
      indexPos: listLength + 1,
      newStudent: true,
    });

    // If the initial list had only one student and we added another, remove the error tooltip from the list.
    if (newStudents.length === 2) {
      _.each(newStudents, function (student) {
        student.hideTooltip = true;
      });
    }

    this.newStudents = newStudents;
    return newStudents;
  },

  removeNewStudent: function (index) {
    // Remove the student at index and reorder the list of students.
    let newStudents = this.newStudents;

    newStudents = _.without(
      newStudents,
      _.findWhere(newStudents, { indexPos: index })
    );
    _.each(newStudents, function (newStudent, index) {
      newStudent.indexPos = index + 1;
    });

    // If there is only one student in the modal, show the tooltip error.
    if (newStudents.length === 1) {
      _.each(newStudents, function (student) {
        student.hideTooltip = false;
      });
    }

    // When only one student is in the modal and the teacher removes it, close the modal.
    if (newStudents.length === 0) {
      this.trigger('modal:close');
      return;
    }

    this.newStudents = newStudents;
    return newStudents;
  },

  saveNewStudents: function (roomId, isSingle = false) {
    let newStudents = this.newStudents;
    let activeRoster = this.get('roster_in_edit'); // This returns the room being edited;
    let allStudentsInvalid = true;

    // Iterate over the students and revalidate each.
    for (let student of newStudents) {
      let errors = {};

      if (student.first_name === '') {
        errors.first_name = translate('Please provide a first name.');
      }

      if (student.last_name === '') {
        errors.last_name = translate('Please provide a last name.');
      }

      if (student.student_id === '') {
        errors.student_id = translate('Please provide an ID.');
      } else if (this.isIdDuplicated(student.student_id)) {
        errors.student_id = translate('This ID is already in use.');
      }

      if (student.email && !Validations.isValidEmail(student.email)) {
        errors.email = translate('Please provide a valid email address');
      } else if (this.isEmailDuplicated(student.email)) {
        errors.email = translate('This email is already in use.');
      }

      if (!isSingle) {
        // Remove new students that have all fields invalid.
        if (errors.first_name && errors.last_name && errors.student_id) {
          this.removeNewStudent(student.indexPos);
        } else {
          allStudentsInvalid = false;
        }
      }

      student.errors = errors;
    }

    newStudents = this.newStudents.map((student) => {
      return {
        first_name: student.first_name,
        last_name: student.last_name,
        student_id: student.student_id,
        email: student.email,
      };
    });

    let activeErrors = _.filter(this.newStudents, function (student) {
      return !_.isEmpty(student.errors);
    });

    if (activeErrors.length < 1) {
      request.post({
        url: `${window.APP_CONFIG.TEACHER_SERVICE}/rooms/${roomId}/roster/student/`,
        data: {
          students: newStudents,
        },
        success: (data) => {
          // Capture rostered state BEFORE the mutations below flip it — used to
          // detect a room *first* becoming rostered (for the hand-raise mirror).
          const wasRostered = activeRoster.rostered;
          const { student_count: oldStudentCount = 0 } = activeRoster;
          let updatedStudentCount = 0;

          _.each(data.students, function (student) {
            student.inEdit = false;
            updatedStudentCount++;
          });

          new UpdateRoomRosterEventAdapter({
            newStudentCount: oldStudentCount + updatedStudentCount,
            oldStudentCount: oldStudentCount,
          }).sendAnalytics();

          if (activeRoster.roster) {
            activeRoster.roster = data.students.concat(activeRoster.roster);
            activeRoster.student_count += updatedStudentCount;
          } else {
            activeRoster.roster = data.students;
            activeRoster.student_count = updatedStudentCount;
          }

          activeRoster.newStudents = [];
          activeRoster.rostered = true;

          // If we added students to the current room, update the room model.
          if (activeRoster.name === roomModel.getRoomName()) {
            roomModel.set({
              students: activeRoster.roster,
              student_count: activeRoster.student_count,
              rostered: true,
            });

            // Hand-raise defaults ON when a room first becomes rostered
            // (SOC-5767; backend RosterService sets ROOM_HANDRAISE_BIT at the
            // same point). Mirror it into the legacy user model so the header
            // StudentMenu toggle reflects ON immediately on the navigate below,
            // without a page refresh. Gated to first-rostering so re-rostering
            // an existing room can't override a teacher who turned it off.
            if (!wasRostered) {
              user.setHandraiseStatus(true);
            }

            Backbone.history.navigate('rooms', { trigger: true });
          }

          if (isSingle) {
            activeRoster.new_students_list = [];
          } else {
            this.trigger('modal:close');
          }

          activeRoster.notify = {
            status: true,
            message: translate('Students added!'),
          };

          this.updateRoomsList();

          setTimeout(() => {
            activeRoster.notify = '';
            this.updateRoomsList();
          }, this.get('notify_timer'));
        },
        error: (response) => {
          popup.render({
            title: translate('Unknown Error'),
            message: translate(
              'This roster is currently unavailable. Please try again later.'
            ),
          });
        },
      });
    } else {
      // If we're adding a single student inline, force a rerender of the page.
      if (isSingle) {
        this.updateRoomsList();
      } else {
        if (allStudentsInvalid) {
          this.trigger('modal:close');
        } else {
          return this.newStudents;
        }
      }
    }
  },

  cancelAddingNewStudents: function (room_name) {
    let model = this;

    let activeRoster = model.get('roster_in_edit');
    activeRoster.newStudents = [];
    model.updateRoomsList();
  },
});

module.exports = new RoomsModel();
